import styled, { css } from 'styled-components';

import { Arrow } from 'shared/icons/Arrow';
import { t } from 'localization/utils/t';

const TP = 'timeline.components.TimelineNavigationButton';

interface ITimelineNavigationButton {
  direction: 'left' | 'right';
}
export const TimelineNavigationButton = ({ direction }: ITimelineNavigationButton) => (
  <TimelineNavigationButton.Button
    className={`swiper-button-${direction === 'left' ? 'prev' : 'next'}`}
    $direction={direction}
  >
    <TimelineNavigationButton.ArrowWrapper
      data-qa={`${direction === 'left' ? 'previous' : 'next'}_year_arrow`}
      aria-label={
        direction === 'left'
          ? t(`${TP}.previous`, 'Previous year arrow')
          : t(`${TP}.next`, 'Next year arrow')
      }
    >
      <Arrow direction={direction} />
    </TimelineNavigationButton.ArrowWrapper>
  </TimelineNavigationButton.Button>
);

TimelineNavigationButton.ArrowWrapper = styled.div`
  visibility: hidden;
  opacity: 0;
`;

TimelineNavigationButton.Button = styled.button<{
  $direction: ITimelineNavigationButton['direction'];
}>`
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    ${({ $direction }) =>
      $direction === 'left' &&
      css`
        left: 0;
        background: linear-gradient(to right, white 27.08%, rgba(255, 255, 255, 0) 100%);
      `};

    ${({ $direction }) =>
      $direction === 'right' &&
      css`
        right: 0;
        background: linear-gradient(to left, white 27.08%, rgba(255, 255, 255, 0) 100%);
      `};
  }
`;
